// extracted by mini-css-extract-plugin
export default {"selectorMaxWidth":"cF2pUWPgm44EbIrrIn2g","popupDimensions":"o9wp973GgD6yx_snFwGm","thumbImage":"HLR5rVtpplooLbb0pONk"};